import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardFooter from "../../components/Card/CardFooter.js";

import { useHistory } from "react-router-dom";

import { createCriteria } from "../../api/apiCriteria.js";

import Criterion from "../../components/Criteria/Criterion";
import { isAuthenticated } from "../../utils/authService";
import { showWarningToast } from "../../utils/toastMessages";
import { ToastContainer } from "react-toastify";
import { validateCriterion } from "../../utils/criterionValidation";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);

export default function CreateCriteria() {
  const history = useHistory(); // Initialize useHistory hook

  const [criteria, setCriteria] = useState([]);
  const [nextId, setNextId] = useState(0);
  const [enableAddButton, setEnableAddButton] = useState(false);

  const addCriterion = () => {
    setCriteria([...criteria, { id: nextId, data: {} }]);
    setEnableAddButton(true);
    setNextId(nextId + 1);
  };

  const removeCriterion = (id) => {
    setCriteria((prevCriteria) => {
      const updatedCriteria = prevCriteria.filter(
        (criterion) => criterion.id !== id
      );

      if (updatedCriteria.length === 0) {
        setEnableAddButton(false);
        setNextId(0);
      }

      return updatedCriteria;
    });
  };

  const updateCriterionData = (id, newData) => {
    setCriteria(
      criteria.map((criterion) =>
        criterion.id === id ? { ...criterion, data: newData } : criterion
      )
    );
  };

  const handleSubmit = async () => {
    let dataValid = true;
    for (const criterion of criteria) {
      const validation = validateCriterion(criterion.data);

      if (!validation.success) {
        showWarningToast({
          title: validation.title,
          message: validation.message,
        });
        return;
      }

      dataValid = dataValid & validation.success;
    }

    if (dataValid) {
      const dataToSend = criteria.map((criterion) => criterion.data);
      try {
        const results = await createCriteria(dataToSend);
        history.push("/admin/showallcriteria");
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      {!isAuthenticated() && (
        <p>Kreiranje kriterijuma dozvoljeno samo administratorima!</p>
      )}
      {isAuthenticated() && (
        <>
          <ToastContainer />
          <div>
            <Button color="success" onPress={addCriterion}>
              + Novi kriterijum
            </Button>
            <GridContainer>
              {criteria.map((criterion) => (
                <GridItem
                  xs={12}
                  sm={6}
                  md={3}
                  id={criterion.id}
                  key={criterion.id}
                >
                  <Card>
                    <Criterion
                      id={criterion.id}
                      data={criterion.data}
                      updateData={updateCriterionData}
                    />

                    <CardFooter>
                      <Button
                        color="danger"
                        onPress={() => removeCriterion(criterion.id)}
                      >
                        Ukloni
                      </Button>
                    </CardFooter>
                  </Card>
                </GridItem>
              ))}
            </GridContainer>
            {enableAddButton && (
              <Button color="success" onPress={handleSubmit}>
                Dodaj kriterijume
              </Button>
            )}
          </div>
        </>
      )}
    </>
  );
}
